import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../../utils/request';
import { METHOD_DELETE } from '../../../constants/api';
import { removeCoOrder } from '../../../actions/coilovers/orders/patchCoOrders';

const deleteCoOrder = createAsyncThunk('coOrders/deleteCoOrder',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      await authSet(METHOD_DELETE, `/co/orders/${id}`);
      dispatch(removeCoOrder(id));
      return id;
    } catch (error) {
      return rejectWithValue(error.message || 'Something went wrong');
    }
  });

export default deleteCoOrder;
